import { AuditLogDiff, RefValue } from "@common/types/auditLog";

export const CLIENT_ACCESS_DIFF_FIELD = "clientWorkspaceIds";

export function getAffectedClientWorkspaceIds(
    diffs: readonly AuditLogDiff[],
): string[] {
    const affectedIds = diffs
        .filter(({ field }) => field === CLIENT_ACCESS_DIFF_FIELD)
        .flatMap(({ before, after }) => {
            const beforeIds = toStringArray(before);
            if (!Array.isArray(after.value)) {
                return beforeIds;
            }

            const afterIds = toStringArray(after);
            return [
                ...afterIds.filter((id) => !beforeIds.includes(id)),
                ...beforeIds.filter((id) => !afterIds.includes(id)),
            ];
        });

    return [...new Set(affectedIds)];
}

export function toStringArray({ value }: RefValue): string[] {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter((item): item is string => typeof item === "string");
}
